/* hexa-click-capture.js
   Preserves the Google Ads click id (gclid / gbraid / wbraid) from the landing
   URL by writing it onto the cart as an order note attribute. This survives
   Shopify's 255-char landing_site truncation, so the offline-conversion upload
   (upload_verified_revenue.py) receives the full, valid click id.

   Design notes:
   - No dependencies, loads deferred, never blocks render.
   - Reads the id from the live URL (full, never truncated) and stores it.
   - Makes at most ONE /cart/update.js call per distinct click id.
   - Note attributes are not subject to the 255-char cap that breaks landing_site.
*/
(function () {
  'use strict';

  var KEYS = ['gclid', 'gbraid', 'wbraid'];      // Google issues one of these per click
  var STORE_KEY = 'hexa_gads_click';             // {gclid?,gbraid?,wbraid?,ts}
  var PUSHED_KEY = 'hexa_gads_click_pushed';      // signature already written to cart
  var MAX_AGE_MS = 90 * 24 * 60 * 60 * 1000;      // Google's click lookback window

  function readStored() {
    try { return JSON.parse(localStorage.getItem(STORE_KEY) || 'null'); }
    catch (e) { return null; }
  }
  function save(obj) {
    try { localStorage.setItem(STORE_KEY, JSON.stringify(obj)); } catch (e) {}
  }

  // 1. Capture any click id present in the current (full, untruncated) URL.
  var params;
  try { params = new URLSearchParams(window.location.search); }
  catch (e) { return; }

  var found = {};
  KEYS.forEach(function (k) {
    var v = params.get(k);
    if (v) { found[k] = v; }
  });

  var stored = readStored();
  // Drop a stored id once it is past Google's lookback window.
  if (stored && stored.ts && (Date.now() - stored.ts) > MAX_AGE_MS) { stored = null; }

  if (Object.keys(found).length) {
    found.ts = Date.now();
    stored = found;                 // the newest click wins
    save(stored);
  }

  if (!stored) { return; }          // nothing to attach

  // 2. Write to the cart at most once per distinct click id.
  var signature = KEYS.map(function (k) { return stored[k] || ''; }).join('|');
  var pushed = null;
  try { pushed = localStorage.getItem(PUSHED_KEY); } catch (e) {}
  if (pushed === signature) { return; }

  var attributes = {};
  KEYS.forEach(function (k) { if (stored[k]) { attributes[k] = stored[k]; } });

  fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ attributes: attributes })
  }).then(function (r) {
    if (r && r.ok) {
      try { localStorage.setItem(PUSHED_KEY, signature); } catch (e) {}
    }
  }).catch(function () { /* non-blocking: a failed write simply retries next page */ });
})();
